import { Target } from 'lucide-react';
import { PhaseStubPage } from '@/components/layout/PhaseStubPage';

export function CompetitorsPage() {
  return (
    <PhaseStubPage
      title="Competitors"
      phase={6}
      modules={[
        'Competitor master list with logo, segment, and primary channels',
        'Pricing observations over time per SKU equivalent',
        'Lead-time + rating snapshots (review aggregators)',
        'Share-of-voice tracking against our brand keywords',
      ]}
      icon={Target}
    />
  );
}
